import { useSelector } from '@grandvisionhq/state';
import { useRxGlassesConfiguratorContext } from '../Context/RxGlassesConfiguratorContext.js';
import { hasVisitedStepLensPackage, hasVisitedStepAddOn, getSelectedFrame, getSelectedLensType, getSelectedPackage, getSelectedAddOn, getBundlePrice } from '../../state/configurator/selectors.js';

const useConfigurationSummary = ()=>{
    const { id  } = useRxGlassesConfiguratorContext();
    const hasVisitedStepLensPackage$1 = useSelector((s)=>hasVisitedStepLensPackage(s, {
            id
        })
    );
    const hasVisitedStepAddOn$1 = useSelector((s)=>hasVisitedStepAddOn(s, {
            id
        })
    );
    const frame = useSelector(getSelectedFrame);
    const lensType = useSelector(getSelectedLensType);
    const lensPackage = useSelector(getSelectedPackage);
    const addOn = useSelector(getSelectedAddOn);
    const bundlePrice = useSelector((s)=>getBundlePrice(s, {
            id
        })
    );
    return {
        frame,
        lensType,
        lensPackage,
        addOn,
        bundlePrice,
        hasVisitedStepAddOn: hasVisitedStepAddOn$1,
        hasVisitedStepLensPackage: hasVisitedStepLensPackage$1
    };
};
var useConfigurationSummary$1 = useConfigurationSummary;

export { useConfigurationSummary$1 as default };
//# sourceMappingURL=use-configuration-summary.js.map
